import * as ally from 'ally.js';
ally.style.focusSource();
